import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _RATING_SYSTEM_COMPON;

import React from "react";
//Limitless imports
import SmileyRatingSystem from "./smiley-rating-system/SmileyRatingSystem";
import StarRatingSystem from "./star-rating-system/StarRatingSystem";
export var SMILEY_RATING_SYSTEM = "3-faces";
export var STAR_RATING_SYSTEM = "5-stars";
var RATING_SYSTEM_COMPONENTS = (_RATING_SYSTEM_COMPON = {}, _defineProperty(_RATING_SYSTEM_COMPON, STAR_RATING_SYSTEM, StarRatingSystem), _defineProperty(_RATING_SYSTEM_COMPON, SMILEY_RATING_SYSTEM, SmileyRatingSystem), _RATING_SYSTEM_COMPON);

var RatingSystem = function RatingSystem(_ref) {
  var message = _ref.message,
      useDefaultScore = _ref.useDefaultScore,
      rest = _objectWithoutProperties(_ref, ["message", "useDefaultScore"]);

  var _message$custScoreSch = message.custScoreScheme,
      name = _message$custScoreSch.name,
      maxScore = _message$custScoreSch.maxScore,
      defaultScore = _message$custScoreSch.defaultScore;
  var rating = message.customerScore || -1;
  var hasPreviousScore = false;

  if (useDefaultScore && defaultScore && !message.customerScore) {
    rating = defaultScore;
    hasPreviousScore = true;
  }

  if (message.customerScore) {
    hasPreviousScore = true;
  }

  var schemeMaxScore = maxScore; //on mount tell the parent there was a default score

  React.useEffect(function () {
    if (rating !== -1 && !rest.disabled) {
      rest.onClick(rating);
    }
  }, []);
  var ScoreScheme = RATING_SYSTEM_COMPONENTS[name]; //default smiley in case we get sent a string

  ScoreScheme = ScoreScheme || RATING_SYSTEM_COMPONENTS[SMILEY_RATING_SYSTEM];
  return /*#__PURE__*/React.createElement(ScoreScheme, Object.assign({
    rating: rating,
    maxScore: schemeMaxScore,
    hasPreviousScore: hasPreviousScore
  }, rest));
};

export default RatingSystem;
RatingSystem.defaultProps = {
  useDefaultScore: true
};